import { Button, Layout, Modal, Typography } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"

interface ConfirmDialogProps {
    open: boolean
    title?: string
    message: string
    onConfirm: () => void
    onCancel: () => void
    confirmLabel?: string
    cancelLabel?: string
    confirmLoading?: boolean
    cancelDisabled?: boolean
}

export const ConfirmDialog = ({
    open,
    title,
    message,
    onConfirm,
    onCancel,
    confirmLabel,
    cancelLabel,
    confirmLoading,
    cancelDisabled
}: ConfirmDialogProps) => {
    const { t } = useTranslation()
    return (
        <Modal
            open={open}
            backdrop
            header={
                title ? (
                    <Typography variant="h3" align="center">
                        {title}
                    </Typography>
                ) : undefined
            }
            body={
                <Layout.Column gap={4}>
                    <div>
                        <Typography
                            align="center"
                            style={{ whiteSpace: "pre-line" }}
                        >
                            {message}
                        </Typography>
                    </div>
                </Layout.Column>
            }
            footer={
                <Layout.Row gap={1} nowrap>
                    <Button
                        variant="filled"
                        fullWidth
                        onClick={onCancel}
                        disabled={cancelDisabled}
                    >
                        {cancelLabel ?? t("キャンセル")}
                    </Button>
                    <Button
                        variant="filled"
                        color="primary"
                        fullWidth
                        onClick={onConfirm}
                        disabled={confirmLoading}
                        loading={confirmLoading}
                    >
                        {confirmLabel ?? t("OK")}
                    </Button>
                </Layout.Row>
            }
        />
    )
}
